<template>
  <div id="app">
    <!-- App.vue页主要是切换 登陆 和 主页 的路由 -->
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  created(){
    document.title="米粒助教-简单好用的管理系统";
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue